import React from "react";

// Pastille d'état : une encre foncée sur un fond pâle, un ton par signification
// (neutre, info, ok, attention, danger), toujours avec un texte.
const Puce = ({ ton = "neutre", icone, titre, className = "", children }) => (
  <span className={`la-puce la-puce--${ton} ${className}`.trim()} title={titre}>
    {icone && <i className={`fa ${icone}`} aria-hidden="true" />}
    {children}
  </span>
);

export default Puce;
